<template>
   <el-pagination 
       v-if="entities.items && entities.items.length" 
       layout="total, sizes, prev, pager, next, jumper" 
      :page-sizes="[10, 20, 50, 100]" 
      @size-change="$emit('queryEntities')" 
      @current-change="$emit('queryEntities')" 
      :current-page.sync="condition.pageIndexOnView" 
      :page-size.sync="condition.pageSize" 
      :total="entities.total">
   </el-pagination>
</template>
<script>
export default {
  props: {
    entities:{
        type: Object,
        default:()=>{
            items:[]
        },
    },
    condition: {
        type: Object,
        default:()=>{
            return {
                 pageIndexOnView:1,
                 pageSize: 20,
            }
        }
    }
  },
};
</script>

